module.exports = __webpack_public_path__ + "static/media/capa-petfriends.77259cec.png";